module.exports = __webpack_public_path__ + "img/s2P4.314b3dea.png";